import { render, staticRenderFns } from "./VersionEditLayer.vue?vue&type=template&id=78b2e6f2&scoped=true&"
import script from "./VersionEditLayer.vue?vue&type=script&lang=js&"
export * from "./VersionEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./VersionEditLayer.vue?vue&type=style&index=0&id=78b2e6f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b2e6f2",
  null
  
)

export default component.exports